import "normalize.css/normalize.css";
import "mmenu-js/dist/mmenu.css";

import "./Styles/main.css";

// Entry point for JavaScript
import "./Scripts/trefwoord";
